/**
 * User Tasks API — Dismiss an action item ("don't nag me").
 *
 * POST /v1/user-tasks/dismiss
 *
 * Keyed on the task `stableKey`. Permanent, server-side, set-once per user
 * (recorded in the shared UserItemInteraction store, itemType='user_task').
 * Idempotent. Distinct from complete: dismiss hides without asserting the
 * obligation was met.
 *
 * `userId` (optional) is the subject user whose task is dismissed. Omitted →
 * self. Supplied & ≠ self → requires school-admin / super-admin (view-as).
 */

import { z } from 'zod'

export const DismissUserTaskRequestSchema = z
  .object({
    stableKey: z.string().min(1),
    /** Subject user (UsersOnSchools.publicId) to act on; omit for self. */
    userId: z.string().min(1).optional()
  })
  .strict()
export type DismissUserTaskRequest = z.infer<typeof DismissUserTaskRequestSchema>

export const DismissUserTaskResponseSchema = z.object({
  stableKey: z.string(),
  dismissedAt: z.string().datetime()
})
export type DismissUserTaskResponse = z.infer<typeof DismissUserTaskResponseSchema>
